import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Container,
  Dot,
  Img,
  Line,
  Nav,
} from "../../Styles/Global.Styled";
import freshFlowerLogo from "../../assets/Images/fresh_flower_logo_1.png";
import { useNavigate } from "react-router-dom";
import { appPagesSections } from "../../helpers/data";
import { CartContext } from "../../Context/CartContext";
import { css, keyframes } from "styled-components";
import SearchForm from "../../Forms/SearchForm/SearchForm";
import ShoppingCartIcon from "../../Icons/ShoppingCartIcon";
import MobileNavBar from "./MobileNavBar";
import TopBar from "./TopBar";
import useScrollDirection from "../../hooks/useScrollDirection";

const shakeAnimation = keyframes`
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-4px); }
  50% { transform: translateX(4px); }
  75% { transform: translateX(-4px); }
`;
const hideStyle = css`
  display: none;
`;
const bttnsGapStyle = css`
  gap: 1vh;
`;
const contentStyle = css`
  width: 100%;
  padding: 0.25vh 5vw;
  justify-content: space-between;
`;
const cartCountStyle = css`
  color: white;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5vh;
  height: 1.5vh;
  top: -0.75vh;
  right: -0.75vh;
  font-family: sans-serif;
  font-size: 1vh;
  font-weight: 800;
`;
const menuBttnStyle = css`
  display: flex;
  flex-direction: column;
  gap: 0.5vh;
  width: 2.5vh;
  height: 2.5vh;
  padding: 0;
  border-radius: 6px;
  margin-left: 0.75vh;
  align-self: center;
`;
const logoStyle = css`
  height: 7vh;
`;
const navButton = css`
  font-size: 2vh;
  padding: 0 1.5vw;
`;
const cartButtonStyle = css`
  display: flex;
  align-items: center;
  align-self: center;
  animation: ${({ $isShakeOn }) =>
    $isShakeOn &&
    css`
      ${shakeAnimation} 0.5s ease-in-out
    `};
`;
const iconsStyle = { height: "2.5vh", width: "2.5vh" };

const NavBar = ({ setPopUp }) => {
  const [shake, setShake] = useState(true);
  const navigate = useNavigate();
  const scrollDirection = useScrollDirection();

  const { cart } = useContext(CartContext);

  useEffect(() => {
    if (cart.length > 0) {
      setShake(true);
      setTimeout(() => setShake(false), 500);
    }
  }, [cart.length]);

  return (
    <Nav $hide={scrollDirection === "down"}>
      {/* Top Header */}
      <TopBar setPopUp={setPopUp} />
      {/* NavBar Content */}
      <Container $baseStyle={contentStyle}>
        <Img
          $baseStyle={logoStyle}
          src={freshFlowerLogo}
          alt="Logo"
          onClick={() => navigate("/home")}
        />
        <Container>
          {/* Pages buttons */}
          <Container $baseStyle={bttnsGapStyle} $mStyle={hideStyle}>
            {appPagesSections.map((page) => (
              <Button
                $baseStyle={navButton}
                key={page.name}
                onClick={() => navigate(page.url)}
              >
                {page.name}
              </Button>
            ))}
          </Container>
          {/* Search */}
          <SearchForm />
          {/* Shopping cart */}
          <Button
            $isShakeOn={shake}
            $baseStyle={cartButtonStyle}
            onClick={() => navigate("/cart")}
          >
            {cart.length > 0 && (
              <Dot $active $baseStyle={cartCountStyle}>
                {cart.length}
              </Dot>
            )}
            <ShoppingCartIcon style={iconsStyle} />
          </Button>
          {/* Mobile Menu Button */}
          <Button
            $baseStyle={hideStyle}
            $mStyle={menuBttnStyle}
            onClick={() =>
              setPopUp({
                isOpen: true,
                content: <MobileNavBar setPopUp={setPopUp}/>,
                mobileOnly: true,
                isCustom:true,
              })
            }
          >
            <Line /> <Line /> <Line />
          </Button>
        </Container>
      </Container>
    </Nav>
  );
};

export default NavBar;
